<template>
  <v-app>
    <router-view />
    <v-snackbar
      v-model="snackbarOpen"
      :color="snackbar.color"
      :timeout="4000"
      top
      right
    >
      {{ snackbar.text }}
      <v-btn text @click="snackbarOpen = false">OK</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      snackbar: state => state.ui.snackbar
    }),
    snackbarOpen: {
      get() {
        return this.$store.state.ui.snackbar.open;
      },
      set() {
        this.$store.commit("ui/closeSnackbar");
      }
    }
  }
};
</script>
